import React, { useRef, useState } from 'react';
import {
  Box,
  Divider,
  Hidden,
  IconButton,
  InputBase,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem,
  Paper
} from '@mui/material';
import { NavLink } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DirectionsIcon from '@mui/icons-material/Directions';

// Define a type for menu items
interface MenuItem {
  label: string;
  to: string;
}

// List of menu items (you can expand this or import from another file)
const menuItems: MenuItem[] = [
  { label: 'Overview', to: '/overview' },
  { label: 'Tabs', to: '/components/tabs' },
  { label: 'Cards', to: '/components/cards' },
  { label: 'Modals', to: '/components/modals' }
];

const ListWrapper = styled(Box)(
  ({ theme }) => `
    // ... (previous styling remains the same)
  `
);

function HeaderMenu() {
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filteredItems, setFilteredItems] = useState<MenuItem[]>(menuItems);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  // Handle search input change
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);

    // Filter menu items based on search term
    const filtered = menuItems.filter(item => 
      item.label.toLowerCase().includes(value)
    );

    setFilteredItems(filtered);
  };

  return (
    <>
      <ListWrapper
        sx={{
          display: {
            xs: 'none',
            md: 'block'
          }
        }}
      >
        <List disablePadding component={Box} display="flex">
          <Paper
            component="form"
            sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400, backgroundColor:'#e1e1e6' }}
          >
            <IconButton sx={{ p: '10px' }} aria-label="menu">
              <SearchIcon />
              <Hidden smDown>
                <ArrowDropDownIcon sx={{ mT: 1, fontSize: 25 }} />
              </Hidden>
            </IconButton>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Employees"
              inputProps={{ 'aria-label': 'Search Employees' }}
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </Paper>
        </List>
      </ListWrapper>
      <Menu anchorEl={ref.current} onClose={handleClose} open={isOpen}>
        {filteredItems.map((item) => (
          <MenuItem 
            key={item.to} 
            sx={{ px: 3 }} 
            component={NavLink} 
            to={item.to}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default HeaderMenu;